import { BsTropicalStorm } from 'react-icons/bs';
import { FaExclamation, FaHurricane } from 'react-icons/fa6';
import { PiWaves, PiWind, PiWindBold } from 'react-icons/pi';
import { TbStorm } from 'react-icons/tb';

export const beaufortIconComponentsByLevel = Object.freeze({
  0: PiWaves,
  1: PiWaves,
  2: PiWaves,
  3: PiWind,
  4: PiWind,
  5: PiWind,
  6: PiWindBold,
  7: PiWindBold,
  8: PiWindBold,
  9: PiWindBold,
  10: TbStorm,
  11: BsTropicalStorm,
  12: FaHurricane,
});

export const getBeaufortIconComponent = (conditionId) =>
  beaufortIconComponentsByLevel[conditionId] ?? FaExclamation;
